module.exports = __webpack_public_path__ + "static/media/btn-right-disabled.548d2750.svg";